document.addEventListener('DOMContentLoaded', initFormHandler);

function initFormHandler() {
    const cancelOrderForm = document.getElementById('cancel-order-form');
    const successMessage = document.getElementById('cancel-order-success-message');
    const errorMessage = document.getElementById('cancel-order-error-message');
    const submitButton = document.getElementById('cancel-order-submit-button');
    const popup = document.getElementById('cancel-order-popup');

    if (!successMessage || !errorMessage || !submitButton) {
        console.error('Required form elements not found');
        return;
    }

    const successText = successMessage.querySelector('p.note.form-success');
    const errorText = errorMessage.querySelector('p.note.form-error');

    const SUCCESS_MESSAGE = "בקשתך לביטול הזמנה התקבלה, הודעת sms תשלח בהקדם";
    const ERROR_MESSAGE = "התרחשה שגיאה בביטול ההזמנה. אנא נסה שוב.";

    function updateButtonVisibility() {
        const hasVisibleMessage = !successMessage.classList.contains('hide-down') ||
                                  !errorMessage.classList.contains('hide-down');

        if (submitButton) {
            submitButton.style.display = hasVisibleMessage ? 'none' : '';
        }
    }

    updateButtonVisibility();

    const closeButtons = document.querySelectorAll('[data-form-message-close]');
    closeButtons.forEach(button => {
        button.addEventListener('click', () => {
            const message = button.closest('.contact-form__message');
            if (message) {
                message.classList.add('hide-down');
                updateButtonVisibility();
            }
        });
    });

    cancelOrderForm?.addEventListener('submit', (event) => {
        event.preventDefault();
        showCancelPopup();
    });

    function showCancelPopup() {
        if (!popup) {
            // As fallback, if no popup available, submit directly
            submitCancelOrder();
            return;
        }

        const confirmBtn = document.getElementById('cancel-order-confirm-btn');
        const backBtn = document.getElementById('cancel-order-back-btn');
        const overlay = popup.querySelector('.cancel-order-popup-overlay');
        const loader = document.getElementById('cancel-order-loader');

        confirmBtn?.classList.remove('hidden');
        backBtn?.classList.remove('hidden');
        loader?.classList.add('hidden');

        const hidePopup = () => {
            popup.classList.remove('visible');
            loader?.classList.add('hidden');
        };

        backBtn?.addEventListener('click', hidePopup, { once: true });
        overlay?.addEventListener('click', hidePopup, { once: true });
        confirmBtn?.addEventListener('click', () => submitCancelOrder(hidePopup), { once: true });

        popup.classList.add('visible');
    }

    async function submitCancelOrder(hidePopup) {
        const confirmBtn = document.getElementById('cancel-order-confirm-btn');
        const backBtn = document.getElementById('cancel-order-back-btn');
        const loader = document.getElementById('cancel-order-loader');

        confirmBtn?.classList.add('hidden');
        backBtn?.classList.add('hidden');
        loader?.classList.remove('hidden');
        submitButton.disabled = true;

        successMessage?.classList.add('hide-down');
        errorMessage?.classList.add('hide-down');

        const formData = new FormData(cancelOrderForm);
        const orderEmail = formData.get('email');
        const orderName = formData.get('order_number');

        try {
            const response = await fetch('/apps/api/orders/status/manual-cancel', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ orderName, orderEmail }),
            });

            const responseJson = await response.json();

            if (!responseJson.success) {
                throw new Error(responseJson.message || 'An error occurred');
            }

            hidePopup?.();
            successText.textContent = SUCCESS_MESSAGE || 'Your order has been canceled successfully.';
            successMessage.classList.remove('hide-down');
            updateButtonVisibility();
        } catch (error) {
            hidePopup?.();
            errorText.textContent = ERROR_MESSAGE;
            errorMessage.classList.remove('hide-down');
            updateButtonVisibility();
        } finally {
            submitButton.disabled = false;
            loader?.classList.add('hidden');
        }
    }
}
